import { Center } from '@mantine/core';
import { BloodPressureItem } from 'models/bloodpressure';
import { Symptom } from 'models/generic';
import classes from './CalendarBadge.module.css';

interface BloodPressureBadgeProps {
  item?: BloodPressureItem;
  onClick?: (id: string) => void;
}

export const BloodPressureBadge = ({ item, onClick }: BloodPressureBadgeProps) => {
  if (!item) return <></>;
  const hasSymptoms = item?.symptoms && item?.symptoms?.length > 0 && !item?.symptoms?.includes(Symptom.NoSymptoms);
  return (
    <Center
      className={`${classes.calendarBadge} ${hasSymptoms && classes.withSymptoms}`}
      bg={item.classification.color}
      w={55}
      h={30}
      onClick={() => onClick?.(item.id)}
    >
      {item.bloodPressure}
    </Center>
  );
};
